import Vue from 'vue'
import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters)

export default ({ i18n }) => {
  Vue.filter('currency', function (value, currency) {
    if (typeof value !== 'number') {
      return value
    }
    const formatter = new Intl.NumberFormat(i18n.locale, {
      style: 'currency',
      currency
    })
    return formatter.format(value)
  })
}
